import moment from 'moment';

export default function generateDocumentID(documentType, documentDatabaseId, patientDatabseId) {
    const datePart = moment().format("MMDD");
    const zeroPatientId = "000000";
    const zeroDocId = "00";
    const patientDatabaseId = zeroPatientId.substring(0, zeroPatientId.length - patientDatabseId.toString().length) + patientDatabseId.toString();
    const docDatabaseId = zeroDocId.substring(0, zeroDocId.length - documentDatabaseId.toString().length) + documentDatabaseId.toString();
    return `${datePart}${documentType}-${patientDatabaseId}-${docDatabaseId}`;
}